import { Component } from '@angular/core';

@Component({
    selector: 'loading-spinner-grow',
    imports: [],
    templateUrl: './loading-spinner-grow.component.html'
})
export class LoadingSpinnerGrowComponent {

}
